module.exports = __webpack_public_path__ + "c5132edc33a4b5e5471b32e14e508a2b.MP3";